<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div class="sidebar-header">
    <a class="logo" [routerLink]="['/']">
      <img
        [src]="clientConfig?.logo_url || './icons/logo-d2d.svg'"
        alt="logo"
        class="logo-image invert"
      />
      <span class="app-name text-4xl font-semibold leading-normal"></span>
    </a>
    <button
      class="layout-sidebar-anchor z-2"
      type="button"
      (click)="anchor()"
      aria-label="Toggle sidebar"
    ></button>
    <button
      class="layout-sidebar-close"
      type="button"
      aria-label="Cerrar menú"
      (click)="closeMenu()"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div #menuContainer class="layout-menu-container">
    <div client-menu></div>
  </div>
  <div client-topbar *ngIf="isHorizontal() && !layoutService.isMobile()"></div>
</div>
